import {Selection} from './Selection';

export class Order {
  private _userFullName: string;
  private _userEmail: string;
  private _userPhoneNumber: string;
  private _paymentMethodId = 1;
  private _selections: Selection;

  constructor () {
      this._userFullName = '';
      this._userPhoneNumber = '';
      this._userEmail = '';
      this._paymentMethodId = 1;
      this._selections = new Selection();
  }

	get userFullName(): string {
		return this._userFullName;
	}

	set userFullName(value: string) {
		this._userFullName = value;
	}

	get userEmail(): string {
		return this._userEmail;
	}

	set userEmail(value: string) {
		this._userEmail = value;
	}

	get userPhoneNumber(): string {
		return this._userPhoneNumber;
	}

	set userPhoneNumber(value: string) {
		this._userPhoneNumber = value;
	}

	get paymentMethodId(): number {
		return this._paymentMethodId;
	}

	set paymentMethodId(value: number) {
		this._paymentMethodId = value;
	}

	get selections(): Selection {
		return this._selections;
	}

	set selections(value: Selection) {
		this._selections = value;
	}

	setSelectedHall = (val) => {
	  try {
      this.selections.selectedHall = val;
    }catch (error) {
      console.log(error);
    }
	}

	resetSelectedHall = () => {
	  try {
      this.selections.selectedHall = null;
    }catch (error) {
      console.log(error);
    }
	}

	getSelectedHall = () => {
		return this.selections.selectedHall;
	}

	setSelectedDate = (val) => {
		this.selections.selectedDate = val;
	}

	getSelectedDate = () => {
		return this.selections.selectedDate;
	}

	setSelectedTime = (val) => {
		this.selections.selectedTime = val;
	}

	getSelectedTime = () => {
		return this.selections.selectedTime;
	}

	setExtras = (val) => {
		this.selections.extras = val;
	}

	getExtras = () => {
		return this.selections.extras;
	}

	setDress = (val) => {
		this.getExtras().dress = val;
	}

	getDress = () => {
		return this.getExtras().dress;
	}

	setLightSource = (val) => {
		this.getExtras().lightSource = val;
	}

	getLightSource = () => {
		return this.getExtras().lightSource;
	}

	setExtraDressingRoom = (val) => {
		this.getExtras().extraDressingRoom = val;
	}

	getExtraDressingRoom = () => {
		return this.getExtras().extraDressingRoom;
	}

	setNumberOfPersons = (val) => {
		this.getExtras().numberOfPersons = val;
	}

	getNumberOfPersons = ()=> {
		return this.getExtras().numberOfPersons;
	}

	setBathFilling = (val) => {
		this.getExtras().bathFilling = val;
	}

	getBathFilling = () => {
		return this.getExtras().bathFilling;
	}


}

